import styled from 'styled-components';

export const CenterWrapper = styled.div`
  padding-top: 2.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
